<template>
    <div class="ps-3 form-section__group__field">
        <div class="form-group border-start p-3 border-primary">
            <div class="row g-3">
                <div class="d-flex justify-content-between">
                    <div v-if="!print && answerNumber > 0" class="btn btn-danger" @click="remove">
                        {{ $t('common.removeAnswer') }} {{ answerNumber + 1 }}
                    </div>
                    <div v-else class="text-primary fw-bold">
                        <span v-for="(item, index) in $root.t('common.answer')" :key="index">
                            {{ item + ' ' + answerNumber + 1 }}<br />
                        </span>
                    </div>
                </div>

                <div class="col-md-12">
                    <AppInput
                        :name="`answer.nameOfMedicalCondition_${index}`"
                        :label="$root.t('step4.illnessMedicalNameCondition')"
                        rules="required"
                    >
                        <Input v-model="answer.nameOfMedicalCondition" class-name="form-control" />
                    </AppInput>
                </div>

                <div class="col-md-12">
                    <AppInput
                        :name="`answer.dateStarted_${index}`"
                        :label="$root.t('step4.dateStarted')"
                        rules="required|dayBeforeToday"
                    >
                        <AppDatePicker v-model="answer.dateStarted" />
                    </AppInput>
                </div>

                <div class="col-md-12">
                    <AppInput :name="`answer.dateEnded_${index}`" :label="$root.t('step4.dateEnded')">
                        <AppDatePicker v-model="answer.dateEnded" @input="dateValid()" />
                    </AppInput>
                </div>

                <div class="col-md-12">
                    <AppInput :name="`answer.medicalTreatment_${index}`" :label="$root.t('step4.medicalTreatment')">
                        <Input v-model="answer.medicalTreatment" class-name="form-control" />
                    </AppInput>
                </div>

                <div class="col-md-12">
                    <AppInput
                        :name="`CurrentMedicationName_${index}`"
                        :label="$root.t('step4.currentMedicationAndDose')"
                    >
                        <Input v-model="answer.currentMedicationName" class-name="form-control" />
                    </AppInput>
                </div>

                <div class="col-md-12">
                    <AppInputCheck
                        v-model="answer.hasHospitalRelationToCondition"
                        :label="$root.t('step4.stayHospitalWithThisCondition')"
                        rules="required"
                    >
                        <div role="radiogroup">
                            <div class="form-check form-check-inline">
                                <input
                                    :id="`ExistingHealthInsurancePoliciesRadio_${index}-yes`"
                                    v-model="answer.hasHospitalRelationToCondition"
                                    class="form-check-input"
                                    type="radio"
                                    :name="`ExistingHealthInsurancePoliciesRadio_${index}-yes`"
                                    :value="true"
                                />
                                <label
                                    class="form-check-label"
                                    :for="`ExistingHealthInsurancePoliciesRadio_${index}-yes`"
                                    >{{ $t('common.yesAnswer') }}</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input
                                    :id="`ExistingHealthInsurancePoliciesRadio_${index}-no`"
                                    v-model="answer.hasHospitalRelationToCondition"
                                    class="form-check-input"
                                    type="radio"
                                    :name="`ExistingHealthInsurancePoliciesRadio_${index}-no`"
                                    :value="false"
                                />
                                <label
                                    class="form-check-label"
                                    :for="`ExistingHealthInsurancePoliciesRadio_${index}-no`"
                                    >{{ $t('common.noAnswer') }}</label>
                            </div>
                        </div>
                    </AppInputCheck>
                </div>

                <div class="col-md-12">
                    <AppInput
                        :name="`Detail.CurrentCondition_${index}`"
                        :label="$root.t('step4.currentStatus')"
                        rules="required"
                    >
                        <AppSelect
                            v-model="answer.currentConditionId"
                            :placeholder="$t('common.defaultSelectionValue')"
                            :options="$optionData.currentConditions"
                        />
                    </AppInput>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AnswerDetailForm',
    components: {},
    props: {
        answer: {
            type: Object,
            required: true,
        },
        index: {
            type: String,
            required: true,
        },
        answerNumber: {
            type: Number,
            default: 0,
        },
        underwritingQuestionId: {
            type: [String, Number],
            default: '',
        },
        print: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {}
    },
    mounted() {},
    methods: {
        dateValid() {
            if (this.answer && this.answer.dateStarted && this.answer.dateEnded) {
                if (
                    new Date(this.answer.dateStarted).toISOString().slice(0, 10) >
                    new Date(this.answer.dateEnded).toISOString().slice(0, 10)
                ) {
                    this.$toast.open({
                        message: 'Date Stated cannot be greater than Date Ended',
                        type: 'error',
                    })

                    this.answer.dateEnded = ''
                }
            }
        },

        remove() {
            this.$emit('remove', this.underwritingQuestionId, this.answerNumber)
        },
    },
}
</script>
